import { render } from "./employee_absence_modal.vue?vue&type=template&id=88ffdaac"
import script from "./employee_absence_modal.vue?vue&type=script&lang=js"
export * from "./employee_absence_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__